module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Battery-charging-53bd0895738fa9dd85b520486c94e91e.svg";